import { createFeatureActionNamer } from '../redux/action-name';

const getActionName = createFeatureActionNamer('confirmation-dialog');

export const OPEN_DIALOG = getActionName('OPEN_DIALOG');
export const CLOSE_DIALOG = getActionName('CLOSE_DIALOG');
export const OPEN_TOAST = getActionName('OPEN_TOAST');
export const CLOSE_TOAST = getActionName('CLOSE_TOAST');
export const VIEW_MODAL = getActionName('VIEW_MODAL');
